export default __webpack_public_path__ + "static/media/avatar.2824f6ea.svg";